import * as Styled from './OxHorizontalAccordion.styled';

import React, { useEffect, useState } from 'react';
import { EInputTheme, OxThemedInput } from 'src/components/OxThemedInput';
import { DOCTOR_PROFILE_SWITCH_EVENT } from 'src/constants/events';

export type TAccordionItem = {
    id?: string;
    title: string | React.ReactFragment;
    selectTitle: string;
    content: string | React.ReactFragment;
};

type TSelect = {
    title: string;
    value: number;
};

type TProps = {
    items: TAccordionItem[];
    height?: (number | null)[];
};

export const OxHorizontalAccordion = ({ items = [], height }: TProps) => {
    const [activeIndex, setActiveIndex] = useState<number>(0);

    useEffect(() => {
        setActiveIndex(0);
    }, [items]);

    // Dispatch custom event when active index changes to notify doctor profiles
    useEffect(() => {
        if (items.length > 0 && items[activeIndex]) {
            const activeDoctorId = items[activeIndex].id || activeIndex;
            const event = new CustomEvent(DOCTOR_PROFILE_SWITCH_EVENT, {
                detail: { activeDoctorId }
            });
            window.dispatchEvent(event);
        }
    }, [activeIndex, items]);

    return (
        <Styled.Container>
            <OxThemedInput theme={EInputTheme.Gold}>
                <Styled.Select
                    items={items.map(
                        (item, index): TSelect => ({
                            title: item.selectTitle,
                            value: index
                        })
                    )}
                    value={activeIndex}
                    onValueChange={(val: TSelect) => {
                        val && setActiveIndex(val.value);
                    }}
                    labelName="title"
                    valueName="value"
                />
            </OxThemedInput>
            <Styled.List height={height}>
                {items.map((item, index) => (
                    <React.Fragment key={item.id || index}>
                        <Styled.ContentWrapper active={index === activeIndex}>
                            <Styled.Content active={index === activeIndex}>
                                {item.content}
                            </Styled.Content>
                        </Styled.ContentWrapper>
                        <Styled.Title onClick={() => setActiveIndex(index)}>
                            {item.title}
                        </Styled.Title>
                    </React.Fragment>
                ))}
            </Styled.List>
        </Styled.Container>
    );
};
